<template>
  <div id="app">
    <div class="notification-list">
      <div
        v-for="notification in getNotificationList"
        class="notification"
        :class="notification.type ? '--' + notification.type : ''"
        :key="notification.id"
      >
        <h2 class="notification__headline">{{ notification.title }}</h2>
        <p class="notification__text">{{ notification.message }}</p>
        <p class="notification__id">{{ notification.id }}</p>
      </div>
    </div>
    <template v-if="getIsLoadedState">
      <router-view />
    </template>
    <Loading v-else />
  </div>
</template>

<script>
import DeviceType from './helpers/DeviceType';
import Loading from './pages/Loading.vue';
export default {
  components: { Loading },
  name: 'App',
  mounted() {
    // if (DeviceType.isTizen) {
    //   window.tizen.tvwindow.show(
    //     this.callbackShowWindow,
    //     (err) => {
    //       console.log('ERROR SHOW WINDOW', err);
    //     },
    //     ['0', '50%', '50%', '50%'],
    //     'MAIN'
    //   );
    // }
    console.log('MOUNTED');
  },
  beforeDestroy() {},
  methods: {
    callbackShowWindow(context) {
      console.log('WINDOW CONTEXT', context);
    },
  },

  computed: {
    getNotificationList() {
      return this.$store.state.notification.list;
    },
    getIsLoadedState() {
      return this.$store.state.isLoadedState;
    },
  },
};
</script>

<style>
/* body {
  background-color: lightcyan;
  height: 100vh;
  width: 100vw;
  padding: 0;
  margin: 0;
  overflow: hidden;
} */
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: black; */
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  height: 100vh;
  overflow: hidden;
  position: relative;
  text-align: left;
  width: 100vw;
}

.notification-list {
  display: flex;
  flex-direction: column-reverse;
  position: absolute;
  right: 40px;
  top: 80px;
  z-index: 999;
}

.notification {
  background: rgba(0, 0, 0, 0.8);
  border-radius: 15px;
  border: 5px solid transparent;
  box-sizing: border-box;
  color: rgba(250, 250, 250);
  margin-bottom: 5px;
  min-height: 10vh;
  padding: 20px;
  width: 40vw;
}
.notification__headline {
  margin: 0;
  margin-bottom: 10px;
  font-size: 35px;
  padding: 0;
  letter-spacing: 1px;
}
.notification__text {
  font-size: 27px;
  padding: 0;
  margin: 0;
}

.--error {
  border-color: red;
}
.--socket {
  border-color: yellowgreen;
}
</style>



// WEBPACK FOOTER //
// src/App.vue